import { styled } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import UploadHeader from "../components/upload/UploadHeader";
import UploadSteps from "../components/upload/UploadSteps/UploadSteps";
import { NotAuthorizedPopup } from "../components/popups";
import { fetchNiches } from "../store/niches/niches-action";
import { fetchTags } from "../store/tags/tags-action";
import { sizes } from "../theme/themeConstants";
import { useIsAuth } from "../hooks";

export const UploadPage = () => {
  const isAuth = useIsAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTags());
    dispatch(fetchNiches());
    // eslint-disable-next-line
  }, [])

  document.title = "Uploader | RedGIFs";

  return (
    <Container>
      <UploadHeader
        title="Upload"
      />
      { isAuth ? <UploadSteps/> : <NotAuthorizedPopup /> }
    </Container>
  );
};

const Container = styled("div")({
  paddingTop: "24px",
  maxWidth: sizes.containerSize,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  minHeight: "90%",
  margin: "auto",
  "@media screen and (max-width: 767px)": {
    padding: "1rem",
    textAlign: "center"
  }
});
